import styles from "./InputField.module.scss";
import { useState } from "react";
import Button from "../ui/Button";

const FileField = ({
  name,
  label,
  register,
  validation = {},
  errors,
  setValue,
  setError,
  clearErrors,
  required = false,
  accept = "",
  isStatic = false,
  maxSize = null,
}) => {
  // TODO: 必要になったら確認画面用のファイル名表示部分作る
  const [fileName, setFileName] = useState("");

  const onChange = (e) => {
    // 初期化
    setFileName("");
    setValue(name, null);
    clearErrors(name);

    const file = e.target.files[0];

    if (!file) return;

    if (maxSize && file.size > maxSize) {
      var max_size_conv = convertSize(maxSize);
      setError(name, {
        message: `サイズが${max_size_conv}を超えています。`,
      });
      return;
    }
    const reader = new FileReader();
    reader.onload = (event) => {
      // json形式で送信するためにファイルをエンコードする
      const base64Text = event.currentTarget.result;
      // 値セット
      setValue(name, base64Text);
    };
    reader.readAsDataURL(file);

    setFileName(file.name);
  };

  const selectFile = () => {
    document.querySelector("input[type='file']").click();
  };

  const convertSize = (size) => {
    var conv_size = size / 1024;
    if (conv_size < 1024) {
      return String(conv_size) + "KB";
    }
    conv_size /= 1024;
    return String(conv_size) + "MB";
  };

  return (
    <div className={styles.field}>
      <label className={`form-label ${styles.field__label}`}>
        {label}
        <span className={styles.field__label__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </label>
      <Button type="button" styleType="upload" onClick={() => selectFile()}>
        ファイルを選択
      </Button>
      <p className={styles.filestaticlabel}>
        {fileName.length > 0 ? <p>{"ファイル名：" + fileName}</p> : <></>}
        {errors[name] && errors[name].type === "required" ? (
          <p className={`${styles.caution}`}>ファイルが選択されていません。</p>
        ) : errors[name] ? (
          <p className={`${styles.caution}`}>{errors[name].message}</p>
        ) : (
          <></>
        )}
      </p>
      <input
        className="d-none"
        type="file"
        accept={accept}
        onChange={(e) => onChange(e)}
      />
      <input
        type="hidden"
        name={name}
        {...register(name, {
          ...validation,
        })}
      />
    </div>
  );
};

export default FileField;
